// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chips / etiquetas para estados en consultas OC, facturas y modales relacionados */

.consultationStatusTags_tag__8WAFw {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  white-space: nowrap;
  letter-spacing: 0.02em;
  border: 1px solid transparent;
}

.consultationStatusTags_tagMuted__c3n38 {
  background: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
}

.consultationStatusTags_tagNeutral__oxh5L {
  background: #e2e8f0;
  color: #334155;
  border-color: #cbd5e1;
}

.consultationStatusTags_tagWarning__aI2e2 {
  background: #fef9c3;
  color: #854d0e;
  border-color: #fde047;
}

.consultationStatusTags_tagSuccess__TaWYc {
  background: #dcfce7;
  color: #14532d;
  border-color: #86efac;
}

.consultationStatusTags_tagDanger__emWNo {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.consultationStatusTags_tagInfo__3ZwLc {
  background: #e0e7ff;
  color: #312e81;
  border-color: #c7d2fe;
}

.consultationStatusTags_tagOrange__EFiit {
  background: #ffedd5;
  color: #9a3412;
  border-color: #fdba74;
}
`, "",{"version":3,"sources":["webpack://./src/styles/consultationStatusTags.module.css"],"names":[],"mappings":"AAAA,oFAAoF;;AAEpF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["/* Chips / etiquetas para estados en consultas OC, facturas y modales relacionados */\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.25;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  letter-spacing: 0.02em;\n  border: 1px solid transparent;\n}\n\n.tagMuted {\n  background: #f1f5f9;\n  color: #475569;\n  border-color: #e2e8f0;\n}\n\n.tagNeutral {\n  background: #e2e8f0;\n  color: #334155;\n  border-color: #cbd5e1;\n}\n\n.tagWarning {\n  background: #fef9c3;\n  color: #854d0e;\n  border-color: #fde047;\n}\n\n.tagSuccess {\n  background: #dcfce7;\n  color: #14532d;\n  border-color: #86efac;\n}\n\n.tagDanger {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.tagInfo {\n  background: #e0e7ff;\n  color: #312e81;\n  border-color: #c7d2fe;\n}\n\n.tagOrange {\n  background: #ffedd5;\n  color: #9a3412;\n  border-color: #fdba74;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": `consultationStatusTags_tag__8WAFw`,
	"tagMuted": `consultationStatusTags_tagMuted__c3n38`,
	"tagNeutral": `consultationStatusTags_tagNeutral__oxh5L`,
	"tagWarning": `consultationStatusTags_tagWarning__aI2e2`,
	"tagSuccess": `consultationStatusTags_tagSuccess__TaWYc`,
	"tagDanger": `consultationStatusTags_tagDanger__emWNo`,
	"tagInfo": `consultationStatusTags_tagInfo__3ZwLc`,
	"tagOrange": `consultationStatusTags_tagOrange__EFiit`
};
export default ___CSS_LOADER_EXPORT___;
